import React from 'react';
import styles from './Home.module.scss';
import Box from '@/components/UI/box/Box';
import { ProductListRecord } from '@/components/reusable/productCard/types';
import { blogCarouselType, housesStatistics } from '@/components/home/type';
import HousesCarousel from '@/components/home/housesCarousel/HousesCarousel';
import BlogCarousel from '@/components/home/blogCarousel/BlogCarousel';
import dynamic from 'next/dynamic';
import LeadBoxSkeleton from './leadbox/leadBoxSkeleton/LeadBoxSkeleton';
import { useIsWhiteLabel } from '../app/providers/whiteLabelProvider/WhiteLabelProvider';
import { getEnvs } from '@/helpers/getEnvs';
import { checkIsProduction } from '@/helpers/checkEnvironments';
const LeadBox = dynamic(() => import('@/components/home/leadbox/LeadBox'), {
  ssr: false,
  loading: LeadBoxSkeleton
});
const TimeComponent = dynamic(() => import('@/components/home/housesCarousel/timeComponent/TimeComponent'), {
  ssr: false
});
type Props = {
  data: {
    lateNight: ProductListRecord[];
    nearTehran: ProductListRecord[];
    tehran: ProductListRecord[];
    north: ProductListRecord[];
    south: ProductListRecord[];
    ecotourism: ProductListRecord[];
    blog: blogCarouselType[];
    statistics: housesStatistics;
  };
};
const isProduction = checkIsProduction();
const Home: React.FC<Props> = ({
  data
}) => {
  const isWhiteLabel = useIsWhiteLabel();
  return <Box className={styles['styled-home']} data-sentry-element="Box" data-sentry-component="Home" data-sentry-source-file="Home.tsx">
      {data?.lateNight.length !== 0 && <HousesCarousel title="لحظه آخری" description="مشاهده همه لحظه آخری‌ها" href="/search?late_night=1" lateNight list={data?.lateNight}>
          <TimeComponent />
        </HousesCarousel>}
      <HousesCarousel title="ویلاهای شمال" description="مشاهده همه ویلاهای شمال" href="/search?phrase=شمال" list={data?.north} data-sentry-element="HousesCarousel" data-sentry-source-file="Home.tsx" />
      <HousesCarousel title="ویلاهای اطراف تهران" description="مشاهده همه ویلاهای اطراف تهران" href="/search?near_cities=تهران" list={data?.nearTehran} data-sentry-element="HousesCarousel" data-sentry-source-file="Home.tsx" />
      <HousesCarousel title="اقامتگاه‌های تهران" description="مشاهده همه اقامتگاه‌های تهران" href="/search/city/تهران" list={data?.tehran} data-sentry-element="HousesCarousel" data-sentry-source-file="Home.tsx" />
      <HousesCarousel title="اقامتگاه‌های جنوب" description="مشاهده همه اقامتگاه‌های جنوب" href="/search?phrase=جنوب" list={data?.south} data-sentry-element="HousesCarousel" data-sentry-source-file="Home.tsx" />
      <HousesCarousel title="اقامتگاه‌های بوم‌گردی" description="مشاهده همه اقامتگاه‌های بوم‌گردی" href="/all-boomgardi" list={data?.ecotourism} data-sentry-element="HousesCarousel" data-sentry-source-file="Home.tsx" />
      <LeadBox data-sentry-element="LeadBox" data-sentry-source-file="Home.tsx" />
      {isProduction && !isWhiteLabel && <BlogCarousel blogPostList={data?.blog} />}
    </Box>;
};
export default Home;